<template>
<div class="yk-course-container-main">
    <div class="yk-course-new-content clearfix">
        <div class="clearfix search-head-con">
            <el-input placeholder="请输入课程名或教师名" v-model="keyName" class="input-name-val" size="small">
            </el-input>
            <el-button type="primary" size="small" icon='el-icon-search' @click="getBookMaterialList">搜索</el-button>
            <el-button type="primary" size="small" icon='el-icon-circle-plus-outline' @click="showSave()">添加</el-button>
        </div>
        <img :src="nodataImg" alt="" v-show="courseList.length==0" style="margin:100px auto 0px;display: block;">
        <div class="yk-course-list hor clearfix">
            <template v-for="(li, key) in courseList">
                <el-card class="yk-course" :key="key">
                    <div class="yk-course-go-new" @click="onGotoClassHandler(li.Id,li.Title)">
                        <img class="yk-course-cover-new" :src="li.BookCover || defaultCover" />
                    </div>
                    <div class="yk-course-new-name" :title="li.Title">{{li.Title}}</div>
                    <div class="yk-course-teacher-name">{{li.Author}}</div>
                    <div class="yk-course-publish-new">
                        <el-dropdown trigger="click" @command="onDropdownClickHandler">
                            <el-button class="yk-course__control"><i class="wl-icon-gengduoxiao"></i></el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item :command="{type: 'edit', data: li}">
                                    <span>编辑</span>
                                </el-dropdown-item>
                                <el-dropdown-item :command="{type: 'copy', data: li}">
                                    <span>复制</span>
                                </el-dropdown-item>
                                <el-dropdown-item :command="{type: 'delete', data: li}">
                                    <span>删除</span>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </el-card>
            </template>
            <div class="itemempty"></div>
            <div class="itemempty"></div>
            <div class="itemempty"></div>
        </div>
        <div v-if="courseList.length > 0">
            <el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange" :current-page="pageIndex" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
            </el-pagination>
        </div>
        <el-dialog title="添加教材" :visible.sync="rdialogVisible" width="60%" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="handleClose">
            <div class="material-form-detail clearfix">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm">
                    <el-form-item label="教材名称:" prop="bookName">
                        <el-input v-model="ruleForm.bookName" placeholder="请输入教材名称"></el-input>
                    </el-form-item>
                    <el-form-item label="教材链接：" prop="Link">
                        <el-input v-model="ruleForm.Link" placeholder="请输入教材链接"></el-input>
                    </el-form-item>
                    <el-form-item label="教材编号(ISBN)：" prop="ISBN">
                        <el-input v-model="ruleForm.ISBN" placeholder="请输入教材编号"></el-input>
                    </el-form-item>
                    <el-form-item label="教材简介：" prop="TextBookBrief">
                        <el-input type="textarea" :rows="5" v-model="ruleForm.TextBookBrief"></el-input>
                    </el-form-item>
                    <el-form-item label="价格：" prop="Price">
                        <el-input-number v-model="ruleForm.Price" :precision="2" :step="1"></el-input-number>
                    </el-form-item>
                    <el-form-item label="出版社：" prop="publishName">
                        <el-input v-model="ruleForm.publishName" placeholder="请输入教材出版社"></el-input>
                    </el-form-item>
                    <el-form-item label="发行日期：" prop="IssueDate">
                        <el-date-picker v-model="ruleForm.IssueDate" type="date" placeholder="请选择教材发行日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="作者：" prop="Author">
                        <el-input v-model="ruleForm.Author" placeholder="请输入教材作者"></el-input>
                    </el-form-item>
                    <el-form-item label="作者简介：" prop="Introduction">
                        <el-input type="textarea" :rows="5" v-model="ruleForm.Introduction"></el-input>
                    </el-form-item>

                    <el-form-item label="教材封面：" prop="Cover">
                        <oss-newthumbnail :url="urlAliyunOSS" :files.sync="ruleForm.Cover" format="image" v-if="rdialogVisible" :count="1"></oss-newthumbnail>
                    </el-form-item>
                    <el-form-item label="是否前台展示" >
                        <!-- <el-radio v-model="ruleForm.isShow" label=1>是</el-radio>
                        <el-radio v-model="ruleForm.isShow" label=0>否</el-radio> -->
                        <el-radio-group v-model="ruleForm.isShow">
                            <el-radio :label="1">展示</el-radio>
                            <el-radio :label="0">不展示</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确定</el-button>
            </span>
        </el-dialog>
        
        <!-- 复制 -->
        <el-dialog title="教材复制" :close-on-click-modal="true" :visible.sync="copyDialogVisible" width="740px" class="import-stu-info-dialog" :append-to-body="true">
            <div class="tip-info-main">
                <div class="import-table-con">
                    <span>新教材名称</span><el-input v-model="newCourseTitle" placeholder="请输入新教材名称"></el-input>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="startImport">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 进度条 -->
        <el-dialog title="教材复制中。。。" :close-on-click-modal="true" :visible.sync="percentageVisible" width="740px" class="import-stu-info-dialog" :append-to-body="true">
            <div class="tip-info-main">
                <div class="import-table-con">
                    <el-progress :text-inside="true" :stroke-width="26" :percentage="percentage"></el-progress>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelImport">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</div>
</template>

<script>
import Vue from "vue";
import NewThumbnail from "components/AliyunOSS/NewThumbnail.vue";
export default Vue.extend({
    name: "course-list",
    components: {
        "oss-newthumbnail": NewThumbnail
    },
    data() {
        return {
            urlAliyunOSS: '/api/design/osssign/getsign',
            rdialogVisible: false,
            courseList: [],
            isShowNull: false,
            nodataImg: require("assets/images/the-last-new-nodata-imag.png"),
            defaultCover: require("assets/images/news-bg.png"), // 默认封面
            title: "",
            after: false,
            keyName: "",
            courseInfos: [],
            value: "本校课程",
            //1=>本校课程,2=>外校课程
            type: 1,
            dlpageSize: 10,
            dlpageIndex: 0,
            dltotal: 0,
            AllSchoolList: [],
            impschoolName: "",
            getRowKeys(row) {
                return row.Id;
            },
            courseCheckIds: [],
            courseShareIds: [],
            rules: {
                bookName: [{
                    required: true,
                    message: "请输入教材名称",
                    trigger: "blur"
                }],
                TextBookBrief: [{
                    required: true,
                    message: "请输入教材简介",
                    trigger: "blur"
                }],
                Cover: [{
                    required: true,
                    message: "请添加教材封面",
                    trigger: "blur"
                }],
                ChapterDirectory: [{
                    required: true,
                    message: "请添加章节目录",
                    trigger: "blur"
                }],
                ISBN: [{
                    required: true,
                    message: "请输入教材编码",
                    trigger: "blur"
                }],
                Author: [{
                    required: true,
                    message: "请输入作者",
                    trigger: "blur"
                }],
                IssueDate: [{
                    required: true,
                    message: "请输入发行日期",
                    trigger: "blur"
                }],
                Price: [{
                    required: true,
                    message: "请输入发行定价",
                    trigger: "blur"
                }],
                publishName: [{
                    required: true,
                    message: "请输入出版社",
                    trigger: "blur"
                }],
                Introduction: [{
                    required: true,
                    message: "请输入作者简介",
                    trigger: "blur"
                }]
            },
            ruleForm: {
                ISBN: "",
                Author: "",
                IssueDate: "",
                Id: "",
                CeatedDisplayName: "",
                DateCreated: "",
                CreatedSchoolName: "",
                CourseName: "",
                CourseId: "",
                bookName: "",
                TextBookBrief: "",
                Cover: "",
                ChapterDirectory: [],
                QRcode: "",
                Link: "",
                Price: 0,
                publishName: "",
                Introduction: "",
                schoolId: "",
                isShow:0
            },
            pageIndex: 1,
            pageSize: 10,
            totalCount: 0,
            // 复制
            timer:null,
            taskId:"",
            percentageVisible:false,
            copyDialogVisible:false,
            newCourseTitle:"",
            oldCourseId:"",
            percentage:0
        };
    },
    watch: {
        checkList(val) {
            console.log(val);
        },
        keyName: function (val) {
            this.keyName = val;
            this.getBookMaterialList();
        }
    },
    created() {
        if (location.href.indexOf("clppx") > -1) {
            //现网北京中物联学校

            this.schoolId = "v52hahwqtkdoluiedxd60w";
        } else {
            //测试网
            // this.schoolId = "z3malmq9qlm5epmooablg";
            this.schoolId = "v52hahwqtkdoluiedxd60w";
        }
        this.getBookMaterialList();
    },
    props: {
        certificateId: {
            type: String,
            default: ""
        }
    },
    methods: {
        startCourse(oldCourseId){
            this.oldCourseId = oldCourseId;
            this.copyDialogVisible = true;
        },
        // 开始任务
        startImport(){
            var that= this;
            that.$http
            .post('/api/XOrg/BookMaterial/startCopyCourseInfo', {
                newCourseTitle: that.newCourseTitle,
                courseId: this.oldCourseId
            })
            .then(function (res) {
                that.copyDialogVisible = false;
                that.percentageVisible = true;
                that.taskId = res.taskId;
                that.timer = setInterval(function(){
                    that.$http
                    .post('/api/XOrg/ImportTask/getImportProgress', {
                        id: res.taskId,
                    })
                    .then(function (rst) {
                        if (rst.code > 0) {
                            that.percentage = rst.info.progressBar;
                            if(that.percentage == 100){
                                clearInterval(that.timer);
                                that.percentage = rst.info.progressBar;
                                that.percentageVisible = false;
                                that.pageIndex = 1;
                                that.getBookMaterialList();
                            }
                        } else {
                            that.$message.warning(rst.msg)
                        }
                    })
                }, 2000);
            })
        },
        // 取消进度条
        cancelImport(){
            var that= this;
            that.$http
            .post('/api/XOrg/ImportTask/cancelImport', {
                id: that.taskId,
            })
            .then(function () {
                that.percentageVisible = false;
                clearInterval(that.timer);
            })
        },
        onDropdownClickHandler(cos) {
            var that = this;
            switch (cos.type) {
                case "delete":
                    var arr = [];
                    arr.push(cos.data.Id);
                    that
                        .$confirm("此操作将删除教材, 是否继续?", "提示", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            type: "warning"
                        })
                        .then(() => {
                            that.$http
                                .post("/api/XOrg/BookMaterial/deleteBookMaterial", {
                                    bookIds: arr
                                })
                                .then(rst => {
                                    if (rst.code > 0) {
                                        this.getBookMaterialList();
                                    } else {
                                        that.$message.warning(rst.msg);
                                    }
                                });
                        })
                        .catch(() => {
                            that.$message({
                                type: "info",
                                message: "已取消删除"
                            });
                        });
                    break;
                case "edit":
                    that.getCourseInfo(cos.data.Id);
                    break;
                case "copy":
                    that.startCourse(cos.data.Id);
                    break;
                default:
                    // this.$message.error('');新增
                    break;
            }
        },
        //获取教材详情
        getCourseInfo(Id) {
            var that = this;
            this.$http
                .post("/api/XOrg/BookMaterial/getCourseInfo", {
                    Id: Id
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.ruleForm = rst.bookMaterilInfo;
                        that.rdialogVisible = true;
                    }
                });
        },
        onGotoClassHandler(courseId, name) {
            localStorage.setItem("courseName", name);
            this.$router.push({
                name: "ShareManagement",
                params: {
                    courseId: courseId,
                    folderId: "0",
                    show: "true",
                    sFolderId: "0"
                }
            });
        },
        showSave() {
            this.rdialogVisible = true;
        },
        handleClose() {
            this.ruleForm = {
                ISBN: "",
                Author: "",
                IssueDate: "",
                Id: "",
                CeatedDisplayName: "",
                DateCreated: "",
                CreatedSchoolName: "",
                CourseName: "",
                CourseId: "",
                bookName: "",
                TextBookBrief: "",
                Cover: "",
                ChapterDirectory: [],
                QRcode: "",
                Link: "",
                Price: 0,
                publishName: "",
                Introduction: "",
                schoolId: "",
                isShow:0
            }
            this.$refs['ruleForm'].resetFields();
            this.portalEdit = false;
            this.rdialogVisible = false;
        },
        getBookMaterialList() {
            var that = this;
            that.$http.post("/api/XOrg/BookMaterial/getBookMaterialList", {
                    key: this.keyName,
                    schoolId: this.schoolId,
                    certificateId: this.certificateId,
                    page: this.pageIndex,
                    pageSize: this.pageSize
                })
                .then(rst => {
                    if (rst.code > 0) {
                        that.courseList = rst.list;
                        that.totalCount = rst.pagination.totalCount;
                        if (rst.list.length == 0) {
                            that.isShowNull = true;
                        }
                    }
                });
        },
        submitForm() {
            var that = this;
            this.isButton = false;
            that.$refs["ruleForm"].validate(valid => {
                if (valid) {
                    that.addBookMaterialInfo();
                } else {
                    that.isButton = true;
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        addBookMaterialInfo() {
            var that = this;
            this.$http
                .post("/api/XOrg/BookMaterial/addBookMaterialInfo", {
                    bookId: this.ruleForm.Id,
                    bookName: this.ruleForm.bookName,
                    TextBookBrief: this.ruleForm.TextBookBrief,
                    BookCover: this.ruleForm.Cover,
                    QRcode: this.ruleForm.QRcode,
                    Link: this.ruleForm.Link,
                    ISBN: this.ruleForm.ISBN,
                    Author: this.ruleForm.Author,
                    IssueDate: this.ruleForm.IssueDate,
                    Price: this.ruleForm.Price,
                    publishName: this.ruleForm.publishName,
                    Introduction: this.ruleForm.Introduction,
                    schoolId: this.schoolId,
                    certificateId: this.certificateId,
                    isShow: this.ruleForm.isShow
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.courseList = rst.list;
                        that.getBookMaterialList();
                        that.rdialogVisible = false;
                        that.ruleForm = {};
                    }
                });
        },
        changeCheck(val) {
            this.courseCheckIds = [];
            this.courseShareIds = [];
            val.forEach(element => {
                this.courseCheckIds.push(element.CourseId);
                this.courseShareIds.push(element.Id);
                console.log(this.courseCheckIds);
                console.log(this.courseShareIds);
            });
        },
        handleCheckAllChange(val) {
            this.courseCheckIds = val ? cityOptions : [];
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getBookMaterialList();
        },
        handleCurrentChange(val) {
            this.pageIndex = val;
            this.getBookMaterialList();
        }
    }
});
</script>

<style lang="scss">
.yk-course-container-main {
    padding-bottom: 40px;
    position: relative;

    .search-head-con {
        position: fixed;
        top: 60px;
        right: 0px;
        height: 60px;
        width: calc(100% - 240px);
        z-index: 1000;
        background: #fff;
        text-align: right;
        text-align: right;
        line-height: 60px;

        .input-name-val {
            margin-right: 15px;
            width: 240px;
        }
    }

    .yk-course {
        .el-card__body {
            padding: 0;
        }

        .yk-course__control {
            padding: 0;
            border: 0;
            font-size: 20px;
        }
    }

    .material-form-detail {
        margin-left: 79px;
        width: 60%;

        .mater-form-file {
            .el-upload-list {
                float: left;
                background: #3f5880;
                width: 100%;
                border-radius: 4px;
                margin-bottom: 20px;

                .el-upload-list__item {
                    margin: 0;
                    padding: 6px 0;
                    background: #415474;
                    padding-left: 18px;

                    .el-upload-list__item-name {
                        color: #ffffff;
                        padding-left: 0;

                        .el-icon-document::before {
                            color: #ffffff;
                        }
                    }

                    .el-upload-list__item-status-label {
                        top: 8px;
                        right: 30px;
                        border-radius: 4px;

                        .el-icon-upload-success {
                            color: #409eff;
                        }
                    }

                    .el-icon-close {
                        width: 13px;
                        height: 13px;
                        border-radius: 50%;
                        background: #ee4166;
                        top: 13px;
                        right: 30px;
                        font-size: 10px;
                        line-height: 14px;
                        text-align: center;
                    }

                    .el-icon-close-tip {
                        display: none;
                    }
                }
            }

            .el-upload__tip {
                display: inline-block;
                color: #ee4166;
                margin-top: 0;
            }
        }
    }

    .is-bordered {
        padding: 10px 10px 5px 10px;
    }

    .yk-course-new-content {
        .school-course-name {
            cursor: pointer;
            padding: 20px;
        }

        .school-course-active {
            color: #3fa2ff;
        }

        .yk-course-new-sortContent-new {
            text-align: right;
            position: fixed;
            right: 60px;
            top: 6px;
            z-index: 2000;

            .a-tea-work {
                font-size: 18px;
                width: 105px;
                text-decoration: none;
                color: #eeca1e;
                height: 32px;
                display: inline-block;
                text-align: center;
                line-height: 40px;
                border-radius: 3px;
                margin-right: 15px;

                i {
                    font-size: 26px;
                    float: left;
                }
            }

            .genduo {
                color: #409eff;
                font-size: 25px;
                position: relative;
                top: 5px;
                left: 3px;
            }
        }

        .yk-course-list {
            width: 100%;
            margin: 80px 0 0 30px;

            .yk-course-new-add {
                box-sizing: border-box;
                margin: 0px 16px 22px;
                margin-top: 40px;
                width: 372px;
                height: 320px;
                border: 2px dashed #409eff;
                border-radius: 10px;
                box-shadow: 4px 0px 10px rgba(0, 0, 0, 0.15);
                text-align: center;
                background-color: #fff;
                cursor: pointer;

                .wl-icon-add-wrapper {
                    margin-top: 85px;

                    .wl-icon-tianjia {
                        text-align: center;
                        font-size: 100px;
                        color: #409eff;
                        border: 3px solid #409eff;
                        border-radius: 50%;
                    }
                }

                .yk-add-course-title {
                    margin-top: 29px;
                    font-size: 20px;
                    color: #409eff;
                    line-height: 1;
                }
            }

            .itemempty {
                margin: 0px 16px 22px;
                margin-top: 40px;
                width: 372px;
                height: 0;
            }

            .yk-course {
                position: relative;
                margin-top: 40px;
                width: 300px;
                height: 280px;
                border-radius: 10px;
                box-shadow: 4px 0px 10px rgba(0, 0, 0, 0.15);
                text-align: center;
                cursor: pointer;
                background-color: #fff;
                border: none;
                color: white;
                display: inline-block;
                margin: 0 16px 22px;
                text-decoration: none;

                .yk-course-go-new {
                    width: 100%;
                    height: 180px;

                    .yk-course-cover-new {
                        width: 100%;
                        height: 180px;
                        border-radius: 10px 10px 0 0;
                    }
                }

                .yk-course-new-name {
                    margin-top: 20px;
                    font-size: 18px;
                    color: #333333;
                    width: 70%;
                    margin-left: 15%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .yk-course-teacher-name {
                    margin-top: 18px;
                    color: #999999;
                    font-size: 16px;
                }

                .yk-course-publish-new {
                    position: absolute;
                    right: 15px;
                    bottom: 15px;

                    .el-dropdown {
                        button {
                            background-color: rgba(255, 255, 255, 0.747);

                            .wl-icon-gengduoxiao {
                                font-size: 25px;
                                color: #409eff;
                            }
                        }
                    }
                }
            }

            .img-jp-icon {
                position: absolute;
                bottom: -25px;
                left: -16px;
            }
        }
    }
}

.left {
    float: left;
}

.right {
    float: right;
}

.clearfix::after {
    clear: both;
    display: block;
    content: "";
}

a {
    text-decoration: none;
}
</style>
